import {
  HttpErrorResponse, HttpHandlerFn, HttpRequest
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AuthService } from "../auth.service";

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {

  const router = inject(Router);

  const authService = inject(AuthService);

  // TODO: we still don't know the paths for authentication endpoints
  // currently copy same logic from Velocity
  // replace later when finalized
  if (
    req.url.includes('/auth')
    && !req.url.includes('/auth/welcome/email')
    && !req.url.includes('/auth/token')
    && !req.url.includes('/auth/password')
    && !req.url.includes('/auth/user')
    && !req.url.includes('/auth/user/access')
    && !req.url.includes('/auth/password/access')
    && !req.url.includes('/auth/login/grid')
    && !req.url.includes('/auth/exported/login')
    && !req.url.includes('/auth/inactive')
    && !req.url.includes('/auth/active')
  ) {
    return next(req);
  }

  const token = authService.getStoredAuthToken();

  const authenticatedRequest = token
    ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) })
    : req;

  return next(authenticatedRequest).pipe(catchError((error: HttpErrorResponse) => {
    if ([401, 440].includes(error.status)) {
      authService.signOut();
    }

    // temporarily treat 504 as auth error as well
    if ([504].includes(error.status)) {
      authService.signOut();
      router.navigate(['/login']);
    }

    return throwError(() => error);
  }));

  //TODO: handle refresh token logic
};
